import React from 'react';
import waiverData from './creatorWaiverData';
import map from 'lodash/map'
import { getURLVal } from '../../domains/URLDomain';

class CreatorWaiver extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coachName: null,
      loading: true
    };
  }

  componentDidMount = () => {
    this.fetchCoachName();
  }

  fetchCoachName = async () => {
    const coachOrgId = getURLVal('coachOrgId');
    const coachName = await this.props.actions.signupActions.fetchCoachName(coachOrgId);

    if(coachName){
      this.setState({
        coachName,
        loading: false
      });
    } else {
      this.setState({
        coachName: 'any Trybe Creator',
        loading: false
      });

    }
  }

  renderNavBar = () => {
    return (
      <div className="navbar-section">
        <div className="navbar-content">
          <a href="/" style={{ textDecoration: "none" }}>
            <div className="logo-container">
              <img
                className="logo-img"
                src={require("../../images/trybe-logo-white.svg")}
              />
              <div className="logo-text">TRYBE</div>
            </div>
          </a>
          <div className="right-nav-bar">
            <a href='/faqs' className="nav-text-clickable" style={{ textDecoration: 'none' }}>
              FAQ
              </a>
            <div className="nav-text-clickable" onClick={this.onClickStart}>
              APPLY NOW
              </div>
          </div>
        </div>
      </div>
    )
  }

  renderWaiverSection = (section, idx) => {
    const paragraphs = map(section.paragraphs, (p, idx) => {
      const pText = p.replace('*CREATOR*', this.state.coachName);

      return (
        <div className='section-paragraph-text' key={`paragraph-${idx}`}>
          {pText}
        </div>
      )
    })

    return (
      <div className='waiver-section' key={`section-${idx}`}>
        <div className='section-title-text'>{section.title}</div>
        {paragraphs}
      </div>
    )
  }

  renderWaiver = () => {
    const content = map(waiverData, (section, idx) => {
      return this.renderWaiverSection(section, idx)
    });

    return content;
  }

  renderLoading = () => {
    return (
      <div className='loader-container'>
        <div className='loader'></div>
      </div>
    )
  }

  render() {
    if(this.state.loading){
      return this.renderLoading();
    } else {
      return (
        <div className='creator-waiver-container'>
          {this.renderNavBar()}
          {this.renderWaiver()}
        </div>
      );
    }
  }
}

module.exports = CreatorWaiver;



// WEBPACK FOOTER //
// ./src/components/pages/CreatorWaiver.js